import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { CountryActions, CountryInitProps } from './country.actions';
import * as CountrySelectors from './country.selectors';

@Injectable({ providedIn: 'root' })
export class CountryFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = this.store.pipe(select(CountrySelectors.getCountryLoaded));
  allCountry$ = this.store.pipe(select(CountrySelectors.getAllCountry));
  allCountryEntities$ = this.store.pipe(select(CountrySelectors.getCountryEntities));
  singaporeCountry$ = this.store.pipe(select(CountrySelectors.getSingaporeCountry));

  constructor(private readonly store: Store) {}

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  init(props: CountryInitProps): void {
    this.store.dispatch(CountryActions.init(props));
  }
}
